<template>
  <div>
    <b-row>
      <b-col cols="10">
        <span>
          Registered date:
          <i
            >{{ lien.date | formatDateTime }} -
            {{ lien.user.lastName }}
            {{ lien.user.firstName }}
          </i>
        </span>
        <br />
        <span v-if="lien.status == 0">
          Cancellation date:
          <i
            >{{ lien.cancellationDate | formatDateTime }} -
            {{ lien.cancellationUser.lastName }}
            {{ lien.cancellationUser.firstName }}
          </i>
        </span>
        <br />
        <span v-if="lien.repairDate != null">
          Release date:
          <i>
            {{ lien.repairDate | formatDateTime }} -
            {{ lien.repairUser.lastName }}
            {{ lien.repairUser.firstName }}
          </i>
        </span>
      </b-col>
      <b-col cols="2" class="text-center">
        <div class="d-flex justify-content-end align-items-center">
          <span v-if="lien.status === 0" class="dot dot-danger mr-2" />

          <b-badge v-else class="mr-1" :class="lienStatus.cssClass">
            {{ lienStatus.label }}
          </b-badge>

          <b-dropdown
            v-if="userHasPermission('liens', 'write') && lien.status !== 0"
            size="sm"
            variant="outline-secondary"
            right
            no-caret
          >
            <template #button-content>
              <b-icon icon="three-dots-vertical" />
            </template>

            <b-dropdown-item v-if="lien.status !== 1" @click="setLienStatus(1)">
              Mark as active
            </b-dropdown-item>
            <b-dropdown-item v-if="lien.status !== 2" @click="setLienStatus(2)">
              Mark as completed
            </b-dropdown-item>
            <b-dropdown-item v-if="lien.status !== 3" @click="setLienStatus(3)">
              RDPRM
            </b-dropdown-item>
            <b-dropdown-item v-if="lien.status !== 5" @click="setLienStatus(5)">
              Proof of payment
            </b-dropdown-item>
            <b-dropdown-item v-if="lien.status !== 0" @click="setLienStatus(0)">
              Cancel lien
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col xs="12" sm="12" md="9" lg="9">
        <div class="text-justify mb-1">{{ lien.description }}</div>
        <LienQuittanceUpload
          class="w-75"
          :lien="lien"
          :quittanceFile="lien.quittanceFile"
        />
      </b-col>
      <b-col xs="12" sm="12" md="3" lg="3"> </b-col>
    </b-row>
    <div class="d-flex justify-content-end">
      <div></div>
      <a :href="lien.file" v-b-tooltip.hover title="View file" target="_blank">
        <b-icon
          icon="eye"
          class="float-right cursor-pointer mr-3"
          scale="1.5"
        ></b-icon>
      </a>
      <b-button
        v-if="userHasPermission('liens', 'write')"
        variant="warning"
        size="md"
        v-b-tooltip.hover
        type="button"
        title="Notes"
        class="float-right mx-2 text-white"
        @click="openLienNotesModal()"
      >
        Notes
      </b-button>
    </div>
    <b-list-group v-if="notes.status == 'fetching'" class="mt-2">
      <b-list-group-item class="text-center">
        <b-spinner variant="yellow" />
      </b-list-group-item>
    </b-list-group>
    <b-list-group v-else class="mt-2 mb-2 note-list" tag="ul">
      <b-list-group-item
        v-if="notes.data && !notes.data.length"
        class="text-center"
      >
        <b>No notes to show</b>
      </b-list-group-item>

      <b-list-group-item
        v-for="(note, i) in notes.data"
        :key="i"
        class="flex-column align-items-start"
        tag="li"
      >
        <NoteCard :note="note" :refreshData="getLienNotes" />
      </b-list-group-item>
    </b-list-group>
    <LienNotesModal :lien="lien" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { PUT_LIEN } from "./actions";
import LienNotesModal from "./notes/NotesModal.vue";
import NoteCard from "./notes/NoteCard.vue";
import { superAdminMixin } from "../../mixins";
import LienQuittanceUpload from "./LienQuittanceUpload.vue";
export default {
  props: ["lien", "refreshData"],
  components: { LienNotesModal, NoteCard, LienQuittanceUpload },
  mixins: [superAdminMixin],
  computed: {
    ...mapState({
      vehicle: (state) => state.superAdminStore.vehicle,
      notes: (state) => state.superAdminStore.componentStore.liens.notes.notes,
    }),
    lienStatus() {
      const map = {
        1: { label: "Active", cssClass: "badge-status-active" },
        2: { label: "Completed", cssClass: "badge-status-completed" },
        3: { label: "RDPRM", cssClass: "badge-status-rdprm" },
        5: { label: "Proof of payment", cssClass: "badge-status-proof" },
      };
      return (
        map[this.lien.status] || {
          label: "Unknown",
          cssClass: "badge-status-unknown",
        }
      );
    },
  },
  created() {
    this.getLienNotes();
  },
  methods: {
    setLienStatus(newStatus) {
      this.$store
        .dispatch(PUT_LIEN, { id: this.lien.id, status: newStatus })
        .then(() => {
          this.refreshData();
        })
        .catch(() => {
          this.toastMessage(
            "Lien status could not be updated",
            "Warning",
            "warning"
          );
        });
    },
    openLienNotesModal() {
      this.$bvModal.show("lien-notes-modal" + this.lien.id);
    },
    getLienNotes() {
      this.$store.dispatch("GET_LIEN_NOTES", {
        id: this.lien.id,
      });
    },
  },
};
</script>

<style scoped>
.badge-status-active {
  background-color: #fd7e14 !important;
  color: #fff !important;
}
.badge-status-completed {
  background-color: #54b962 !important;
  color: #fff !important;
}
.badge-status-rdprm {
  background-color: #02afaa !important;
  color: #fff !important;
}
.badge-status-unknown {
  background-color: #6c757d !important;
  color: #fff !important;
}
.badge-status-proof {
  background-color: #ff00ff !important;
  color: #fff !important;
}
</style>
